/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import XcI18next from '@xc/i18next'
import * as toastModal from 'hiya-common/src/components/ToastModal'
import React, {Component} from 'react'
import Helmet from 'react-helmet'
import {connect, useDispatch, useSelector} from 'react-redux'

import clsx from 'clsx'
import {banWebBounces} from '@xc/hiya-jsbridge'
import Bold from '../assets/SF-UI-Text-Bold.otf'
import Medium from '../assets/SF-UI-Text-Medium.otf'
import Regular from '../assets/SF-UI-Text-Regular.otf'
import Semibold from '../assets/SF-UI-Text-Semibold.otf'
import {EnvActions, hLanguageEnum} from '../reducers/env'
// import { Toaster } from "react-hot-toast";
// 自定义Toaster 兼容 ToastModal 与 Toast同时出现
import Toaster from './CustomToaster'

import 'core-js'
import './App.scss'

const shouldBodyTransparentRoutes = ['/walletAdvanced/quick']

const useLanguage: any = () => {
  const dispatch = useDispatch()
  const lang = useSelector((store: any) => store.env.deviceinfo.h_language)
  return [
    lang,
    (newLang) => {
      dispatch(
        EnvActions.set({
          deviceinfo: {
            h_language: newLang,
          },
        })
      )
    },
  ]
}

// // // 新多语言工具的全局配置
// // // 语言初始化与修改方法的hook
XcI18next.config.useLanguage = useLanguage
// // // https://www.i18next.com/overview/configuration-options
// // // 默认语言英语
XcI18next.config.initOptions.debug = false
XcI18next.config.initOptions.fallbackLng = hLanguageEnum.en

class App extends Component<{
  h_language: hLanguageEnum
  baseHref: string
  path: string
  h_web_founction_top: number
  otherInfo: any
}> {
  state = {
    client: false,
  }

  componentDidMount() {
    this.setState({
      client: true,
    })
    // app 级别的公用逻辑可以放到这里
    // 比如白天、夜间模式功能
    // 调用协议禁止IOS回弹
    // window.HiyaJSBridge.callHandler('banWebBounces')
    banWebBounces()
  }

  render() {
    const {h_language, otherInfo, children} = this.props
    const isGame =
      this.props.path.startsWith('/game') && this.props.h_web_founction_top > 0

    return (
      <div className="AppMain">
        <Helmet>
          <title>Higo</title>
          <base href={`//${this.props.baseHref}`} />
          {[Bold, Medium, Regular, Semibold].map((v) => (
            <link
              key={v}
              rel="preload"
              href={v}
              crossOrigin=""
              as="font"
              type="font/otf"
            />
          ))}
          <body
            data-lang={h_language}
            className={clsx({
              bg_clear: !this.state.client || otherInfo.bg_clear || isGame,
            })}
          />
          {shouldBodyTransparentRoutes.includes(this.props.path) && (
            <style>
              {`
              html body {
                background-color: transparent;
              }
            `}
            </style>
          )}
        </Helmet>
        <Toaster
          toastOptions={{
            className: '',
            duration: 3000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
        <div className={toastModal.ToastModalClassName}>
          <div
            style={{
              minHeight: '100.1vh',
            }}
          >
            {this.state.client ? children : ''}
          </div>
        </div>
      </div>
    )
  }
}

export default connect((state) => {
  return {
    h_language: state.env.deviceinfo.h_language,
    h_web_founction_top: state.env.deviceinfo.h_web_founction_top,
    baseHref: state.env.baseHref,
    path: state.env.path,
    otherInfo: state.env.otherInfo,
  }
})(App) as any
